module.exports = __webpack_public_path__ + "img/ip8.b3003e02.png";